import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import FlowDetails from './components/FlowDetails';
import ContractForm from './components/ContractForm';
import ConfigurationPage from './components/ConfigurationPage';
import { CustomThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <CustomThemeProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<h1>Dashboard</h1>} />
            <Route path="/flows/:id" element={<FlowDetails />} />
            <Route path="/contracts" element={<ContractForm />} />
            <Route path="/configuration" element={<ConfigurationPage />} />
            <Route path="*" element={<h1>404: Página no encontrada</h1>} />
          </Routes>
        </Layout>
      </Router>
    </CustomThemeProvider>
  );
}

export default App;

